import * as React from "react";
import { SVGProps } from "react";
export const TableIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M4.5 17C4.04167 17 3.67708 16.8646 3.40625 16.5938C3.13542 16.3229 3 15.9583 3 15.5V4.5C3 4.04167 3.13542 3.67708 3.40625 3.40625C3.67708 3.13542 4.04167 3 4.5 3H15.5C15.9583 3 16.3229 3.13542 16.5938 3.40625C16.8646 3.67708 17 4.04167 17 4.5V15.5C17 15.9583 16.8646 16.3229 16.5938 16.5938C16.3229 16.8646 15.9583 17 15.5 17H4.5ZM9.25 12.25H4.5V15.5H9.25V12.25ZM10.75 12.25V15.5H15.5V12.25H10.75ZM9.25 10.75V7.5H4.5V10.75H9.25ZM10.75 10.75H15.5V7.5H10.75V10.75ZM4.5 6H15.5V4.5H4.5V6Z"
            fill="currentColor"
        />
    </svg>
);
TableIcon.displayName = "TableIcon";
